import React, { memo } from "react";
import clsx from "clsx";
import {
  FormControl,
  InputAdornment,
  OutlinedInput,
  Theme,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";
import isEqual from "react-fast-compare";

const useStyles = makeStyles((theme: Theme) => ({
  searchInput: {
    position: "relative",
    minWidth: 250,
    "& fieldset": {
      borderRadius: 60,
    },
    "& legend": {
      visibility: "hidden",
      maxHeight: 6,
      display: "block",
    },
  },
  progress: {
    position: "absolute",
    right: 7,
    top: 7,
    color: "#1a90ff",
    animationDuration: "550ms",
  },
  input: {
    padding: `${theme.spacing(1)} 0`,
  },
}));

type PropTypes = {
  placeholder: string;
  value: string;
  isSearch?: boolean;
  className?: string;
  onChange(e: React.ChangeEvent<HTMLInputElement>): void;
};

const RoundedInputField = ({
  placeholder,
  value,
  isSearch,
  className,
  onChange,
}: PropTypes) => {
  const classes = useStyles();
  const additionalParams = isSearch
    ? {
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }
    : {};
  return (
    <FormControl className={clsx(classes.searchInput, className)}>
      <OutlinedInput
        placeholder={placeholder}
        id="search-input"
        type="search"
        classes={{
          input: classes.input,
        }}
        value={value}
        autoComplete="off"
        margin="dense"
        // className={classes.input}
        onChange={onChange}
        {...additionalParams}
      />
    </FormControl>
  );
};

export default memo(RoundedInputField, isEqual);
